import React from 'react'
import { Box, Button, Box as Form, Input } from '@node-space/ui-components'
import { RequestErrorCallout } from 'components/Errors/RequestErrorCallout'
import { useChannelEditForm } from '../hooks/useChannelEditForm'

export const ChannelEditForm = () => {
  const {
    register,
    handleSubmit,
    onSubmit,
    errors,
    isDirty,
    isValid,
    isPending,
    requestError,
    walletAction,
    t,
  } = useChannelEditForm()

  return (
    <Form
      tag="form"
      width="full"
      flexCol
      gapY={16}
      onSubmit={handleSubmit(onSubmit)}
      testId="edit-channel-form"
    >
      <Box flexCol>
        <Input
          {...register('channelDescription')}
          label={t('description')}
          inputMode="text"
          name="channelDescription"
          testId="edit-channel-description"
          error={!!errors?.channelDescription}
          errorText={errors?.channelDescription?.message}
        />
      </Box>
      {requestError?.show && <RequestErrorCallout requestError={requestError} />}

      <Box flex justify="between" paddingT={16}>
        <Button testId="cancel" variant="secondary" onClick={walletAction?.onClose}>
          {t('cancel')}
        </Button>

        <Button
          testId="save-channel"
          type="submit"
          variant="primary"
          loading={isPending}
          disabled={!isDirty || !isValid}
        >
          {t('save')}
        </Button>
      </Box>
    </Form>
  )
}
